import { useParams, useNavigate } from 'react-router-dom';
import BookNowButton from '../components/BookNowButton';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

function GirlProfile({ ladies }) {
    const { name } = useParams();
    const navigate = useNavigate();
    const girl = ladies.find(g => g.name.toLowerCase() === name.toLowerCase());

    if (!girl) {
        navigate('/ladies');
        return null;
    }

    return (
        <>
            {/* Fixed Back Button */}
            <div className="fixed top-0 left-0 h-16 px-4 flex items-center z-50">
                <button
                    onClick={() => navigate('/ladies')}
                    className="p-2 rounded-full hover:bg-gray-800 transition-colors duration-200"
                >
                    <ArrowLeftIcon className="w-6 h-6 text-white" />
                </button>
            </div>

            {/* Main Content */}
            <div className="container mx-auto px-4 py-8">
                <div className="flex flex-col md:flex-row gap-8 items-start">
                    {/* Left side - Info */}
                    <div className="w-full md:w-1/2 space-y-6">
                        <h1 className="text-4xl font-bold text-white">{girl.name}</h1>
                        <p className="text-gray-300 text-lg leading-relaxed">{girl.description}</p>
                        <BookNowButton />
                    </div>

                    {/* Right side - Image Grid */}
                    <div className="w-full md:w-1/2">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                            {girl.images.map((image, index) => (
                                <div
                                    key={index}
                                    className="w-full"
                                >
                                    <img
                                        src={image}
                                        alt={`${girl.name} ${index + 1}`}
                                        className="w-full h-auto object-cover"
                                    />
                                </div>
                            ))}
                        </div>
                        <div className="mt-6">
                            <BookNowButton />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default GirlProfile;